/**
 * Application Catalogue Service Hooks
 * React hooks for accessing the CCMS mobile constellation app catalogue.
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all application catalogue services.
 * @returns ApplicationCatalogueServices object containing all catalogue service instances.
 */
export function useApplicationCatalogueServices() {
    const { services } = useCCMS();
    if (!services?.applicationCatalogue) {
        throw new Error('Application catalogue services not available. Ensure CCMSProvider is configured with application catalogue services.');
    }
    return services.applicationCatalogue;
}
/**
 * Hook to access the ApplicationCatalogueService.
 */
export function useApplicationCatalogueService() {
    return useApplicationCatalogueServices().catalogue;
}
/**
 * Hook to access the AppDistributionService — private app distribution and the
 * redemption-code pool. Backs the admin distribution screens and the user's
 * "Get the Apps" download page.
 */
export function useAppDistributionService() {
    return useApplicationCatalogueServices().distribution;
}
//# sourceMappingURL=useApplicationCatalogueServices.js.map